<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.applicant}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{labels.appIntStat}}</v-subheader>
            <div>{{applicantStatus}}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="applicant.appIntStat === 'E'">
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.coyName}}</v-subheader>
            <div v-if="applicant.coyName">{{applicant.coyName}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.coyRocUen}}</v-subheader>
            <div v-if="applicant.coyRocUen">{{applicant.coyRocUen}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.coyNature}}</v-subheader>
            <div v-if="applicant.coyNature">{{applicant.coyNature}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.finInst}}</v-subheader>
            <div>{{commonForm.finInst}} - {{query.finInst}}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appName}}</v-subheader>
            <div v-if="applicant.appName">{{applicant.appName}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appNricPassport}}</v-subheader>
            <div v-if="applicant.appNricPassport">{{applicant.appNricPassport}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appOccupation}}</v-subheader>
            <div v-if="applicant.appOccupation">{{applicant.appOccupation}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.finInst}}</v-subheader>
            <div>{{commonForm.finInst}} - {{query.finInst}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.appAddress}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appAdd3}}</v-subheader>
            <div v-if="applicant.appAdd3">{{applicant.appAdd3}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appPostalCode}}</v-subheader>
            <div v-if="applicant.appPostalCode">{{applicant.appPostalCode}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appAdd1}}</v-subheader>
            <div v-if="applicant.appAdd1">{{applicant.appAdd1}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appAdd2}}</v-subheader>
            <div v-if="applicant.appAdd2">{{applicant.appAdd2}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appAdd4}}</v-subheader>
            <div v-if="applicant.appAdd4">{{applicant.appAdd4}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appState}}</v-subheader>
            <div v-if="applicant.appState">{{applicant.appState}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appCountry}}</v-subheader>
            <div>{{applicant.appCountry}} - {{query.appCountry}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.mailAddress}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.mailAdd3}}</v-subheader>
            <div v-if="applicant.mailAdd3">{{applicant.mailAdd3}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.mailPostalCode}}</v-subheader>
            <div v-if="applicant.mailPostalCode">{{applicant.mailPostalCode}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.mailAdd1}}</v-subheader>
            <div v-if="applicant.mailAdd1">{{applicant.mailAdd1}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.mailAdd2}}</v-subheader>
            <div v-if="applicant.mailAdd2">{{applicant.mailAdd2}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.mailAdd4}}</v-subheader>
            <div v-if="applicant.mailAdd4">{{applicant.mailAdd4}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.mailState}}</v-subheader>
            <div v-if="applicant.mailState">{{applicant.mailState}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.mailCountry}}</v-subheader>
            <div>{{applicant.mailCountry}} - {{query.mailCountry}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.appContact}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appEmail}}</v-subheader>
            <div v-if="applicant.appEmail">{{applicant.appEmail}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appMobileNo}}</v-subheader>
            <div v-if="applicant.appMobileNo">{{applicant.appMobileNo}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appTelNo1}}</v-subheader>
            <div v-if="applicant.appTelNo1">{{applicant.appTelNo1}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appTelNo2}}</v-subheader>
            <div v-if="applicant.appTelNo2">{{applicant.appTelNo2}}</div>
            <div v-else>-</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { salutation, gender, applicantStatus } from '@/const/underwriting'
export default {
  data() {
    return {
      labels: {
        applicant: 'Applicant',
        appIntStat: 'Applicant Status',
        appName: 'Name as in NRIC/Passport',
        appSalutation: 'Salutation',
        appNricPassport: 'NRIC/Passport',
        appOccupation: 'Business/Profession',
        appAddress: 'Applicant Address',
        mailAddress: 'Mailing Address',
        appContact: 'Contacts',
        appEmail: 'Email',
        appMobileNo: 'Mobile No.',
        appTelNo1: 'Home No.',
        appTelNo2: 'Office No',
        coyName: 'Name of Company',
        coyRocUen: 'ROC/UEN',
        coyNature: 'Nature of Business',
        finInst: 'Bank Interest',
        appAdd1: 'Block/House No.',
        appAdd2: 'Street Name',
        appAdd3: 'Unit No.',
        appAdd4: 'Building Name',
        appPostalCode: 'Postal Code',
        appState: 'State',
        appCountry: 'Country',
        mailPostalCode: 'Postal Code',
        mailAdd1: 'Block No.',
        mailAdd2: 'Street Name',
        mailAdd3: 'Unit No.',
        mailAdd4: 'Building Name',
        mailState: 'State',
        mailCountry: 'Country'
      }
    }
  },
  computed: {
    applicant() {
      return this.$store.state.agency.quotation.commonForm.applicant
    },
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    cargoForm() {
      return this.$store.state.agency.quotation.cargoForm
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    },
    applicantStatus() {
      if (this.applicant.appIntStat) {
        return applicantStatus[this.applicant.appIntStat]
      } else {
        return ' - '
      }
    },
    salutation() {
      if (this.applicant.appSalutation) {
        return salutation[this.applicant.appSalutation]
      } else {
        return ' - '
      }
    },
    gender() {
      if (this.applicant.appGender) {
        return gender[this.applicant.appGender]
      } else {
        return ' - '
      }
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  }
}
</script>

<style>
</style>
